import { User } from "@myapp/contract"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { userKeys } from "../keys"
import { userApi } from "../service"

export const useUserDetail = (
  userId: string | undefined,
  options?: Omit<
    UseQueryOptions<User>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery({
    queryKey: userKeys.detail(userId as string),
    queryFn: async () => {
      const { data } = await userApi.getById(userId as string)
      return data
    },
    enabled: !!userId && (options?.enabled ?? true),
    ...options,
  })